import { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useAuthStore } from "../auth";
import { useCartStore } from "../store";

export function Layout() {
	const email = useAuthStore((s) => s.email);
	const logout = useAuthStore((s) => s.logout);
	const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
	const itemCount = useCartStore((s) => s.itemCount());
	const navigate = useNavigate();
	const [sha, setSha] = useState<string>("");

	useEffect(() => {
		const meta = document.querySelector('meta[name="xitester-head-sha"]');
		const content = meta?.getAttribute("content") ?? "";
		setSha(content.slice(0, 7));
	}, []);

	const handleLogout = () => {
		logout();
		navigate("/");
	};

	return (
		<div className="min-h-screen flex flex-col bg-slate-50 text-slate-900">
			<header className="border-b border-slate-200 bg-white">
				<nav className="max-w-6xl mx-auto flex items-center justify-between px-4 py-3">
					<div className="flex items-center gap-6">
						<Link
							to="/"
							data-testid="nav-home"
							className="font-bold text-lg tracking-tight"
						>
							SUT Shopper
						</Link>
						<Link
							to="/products"
							data-testid="nav-products"
							className="text-sm text-slate-700 hover:text-slate-900"
						>
							Products
						</Link>
						<Link
							to="/cart"
							data-testid="nav-cart"
							className="text-sm text-slate-700 hover:text-slate-900 flex items-center gap-2"
						>
							Cart
							<span
								data-testid="nav-cart-count"
								className="inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full bg-slate-900 text-white text-xs"
							>
								{itemCount}
							</span>
						</Link>
					</div>
					<div className="flex items-center gap-4">
						{isAuthenticated() ? (
							<>
								<span className="text-sm text-slate-600">{email}</span>
								<button
									type="button"
									onClick={handleLogout}
									data-testid="nav-logout"
									className="btn-secondary text-sm"
								>
									Logout
								</button>
							</>
						) : (
							<Link
								to="/login"
								data-testid="nav-login"
								className="btn-secondary text-sm"
							>
								Login
							</Link>
						)}
					</div>
				</nav>
			</header>
			<main className="flex-1 max-w-6xl w-full mx-auto px-4 py-8">
				<Outlet />
			</main>
			<footer className="border-t border-slate-200 bg-white">
				<div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between text-xs text-slate-500">
					<span>XiTester SUT Shopper</span>
					<span data-testid="app-sha" className="font-mono">
						{sha}
					</span>
				</div>
			</footer>
		</div>
	);
}

export default Layout;
